import { CloseButton } from '@mybridge/ui/close-button';
import { Image } from '@mybridge/ui/image';
import { VideoPlayer } from '@mybridge/ui/video-player';
import { MediaSlider, MediaSliderItem } from '@mybridge/ui/media-slider';
import { CircularProgress, CircularProgressLabel } from '@mybridge/ui';
import { useContext, useEffect, useState } from 'react';
import { fileToDataURL } from 'v4/lib/file';
import { PostFormContext } from '../context';
import { Box, Stack } from '@mybridge/ui/layout';
import { Text } from '@mybridge/ui/text';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';

export const AttachedMediaContainer = () => {
  const { text, images, videos, gifs, removeImage, removeVideo, removeGif, uploadState } =
    useContext(PostFormContext);
  const [images_, setImages_] = useState([]);
  const [videos_, setVideos_] = useState([]);
  const [gifs_, setGifs_] = useState([]);
  const { t } = useTranslator();

  useEffect(() => {
    prepareImages();
  }, [images]);

  useEffect(() => {
    prepareVideos();
  }, [videos]);

  useEffect(() => {
    prepareGifs();
  }, [gifs]);

  const prepareVideos = async () => {
    const vids = [];
    for (let vid of videos) {
      vids.push(typeof vid === 'string' ? vid : await fileToDataURL(vid));
    }
    setVideos_(vids);
  };

  const prepareImages = async () => {
    const imgs = [];
    for (let img of images) {
      imgs.push(typeof img === 'string' ? img : await fileToDataURL(img));
    }
    setImages_(imgs);
  };

  const prepareGifs = async () => {
    const gs = [];
    for (let gif of gifs) {
      gs.push(gif?.images?.original?.url);
    }
    setGifs_(gs);
  };

  const handleRemoveImage = (file, index) => {
    removeImage?.(file, index);
  };

  const handleRemoveVideo = (file, index) => {
    removeVideo?.(file, index);
  };

  const handleRemoveGif = (file, index) => {
    removeGif?.(file, index);
  };

  const currentVideoFile = videos?.find((v) => v instanceof File);
  let videoUpload = null;
  if (currentVideoFile) {
    const fileId = `${currentVideoFile.name}_${currentVideoFile.size}_${currentVideoFile.lastModified}`;
    videoUpload = uploadState?.[fileId] || Object.values(uploadState || {}).find(
      (item) => item?.file?.name === currentVideoFile.name || item?.fileId?.startsWith(currentVideoFile.name)
    );
  }
  const isVideoUploading = videoUpload && ['initiating', 'uploading', 'completing'].includes(videoUpload.status);
  const percentage = Math.min(100, Math.max(0, Math.round(videoUpload?.percentage || 0)));

  return (
    <>
      {videos_?.length ? (
        <Box pos="relative" borderRadius="5" overflow="hidden">
          <CloseButton
            variant="round"
            zIndex={3}
            onClick={() => handleRemoveVideo(videos_?.[0], 0)}
            bg="white"
            pos="absolute"
            top={2}
            right={2}
          />
          <VideoPlayer src={videos_?.[0]} />
          {isVideoUploading && (
            <Box
              pos="absolute"
              top={0}
              left={0}
              right={0}
              bottom={0}
              bg="blackAlpha.600"
              zIndex={2}
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              gap={3}
              borderRadius="5px"
              pointerEvents="none"
            >
              <CircularProgress
                value={percentage}
                color="#2A6797"
                trackColor="whiteAlpha.300"
                size="64px"
                thickness="8px"
                isIndeterminate={videoUpload?.status === 'initiating' || videoUpload?.status === 'completing'}
              >
                <CircularProgressLabel color="white" fontSize="xs" fontWeight="bold">
                  {`${percentage}%`}
                </CircularProgressLabel>
              </CircularProgress>
              <Text color="white" fontSize="sm" fontWeight="600">
                {videoUpload?.status}
              </Text>
            </Box>
          )}
        </Box>
      ) : (
        <>
          {images_?.length ? (
            <MediaSlider>
              {images_?.map?.((img, index) => (
                <MediaSliderItem
                  key={index}
                  minW="200px"
                  maxH="200px"
                  bg="blackAlpha.800"
                >
                  <CloseButton
                    variant="round"
                    onClick={() => handleRemoveImage(img, index)}
                    bg="white"
                    pos="absolute"
                    top={2}
                    right={2}
                  />
                  <Image maxH="300px" src={img} />
                </MediaSliderItem>
              ))}
            </MediaSlider>
          ) : (
            <>
              {gifs_?.length ? (
                // <Box maxH="200px" overflowY="auto" borderRadius="5">
                <Stack bg="blackAlpha.900" alignItems="center" pos="relative">
                  <CloseButton
                    variant="round"
                    onClick={() => handleRemoveGif(gifs_?.[0], 0)}
                    bg="white"
                    pos="absolute"
                    top={2}
                    right={2}
                  />
                  <Image maxH={'300px'} src={gifs_?.[0]} />
                  {/* </Box> */}
                </Stack>
              ) : (
                ''
              )}
            </>
          )}
        </>
      )}
    </>
  );
};
